import { z } from 'zod';
/** Follow the link sent to the new address of a pending email change. */
export const ConfirmEmailChangeSchema = z.object({
    token: z.string().min(1, 'Confirmation token is required').max(200)
});
